import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { getActiveAccount } from 'preferences/selectors'
import { useAppSelector } from 'store/hooks'
import DiscountsSectionTabs from 'discounts/sectionTabs'
import { getHash, getHashParam, setHash } from 'utils/hash'
import { AddDiscountModal } from './addDiscount'
import { AddPoolModal } from './addPool'
import { DeletePoolModal } from './deletePool'
import { DiscountsHeader, DiscountsToolbar } from './discountsHeader'
import { EditDiscountModal } from './editDiscount'
import { RedeemCodes } from './codes'
import './discounts.scss'

export const Discounts: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const accountSlug = useAppSelector(getActiveAccount)
    const location = useLocation()
    const poolUuid = getHashParam('poolUuid')
    const codeUuid = getHashParam('codeUuid')
    const codeType = getHashParam('codeType') as 'upload' | 'code' | undefined
    const hash = getHash()
    const basePath = `/account/${accountSlug}/discounts`
    const hasSection = location.pathname.includes('/pools') || location.pathname.includes('/codes')

    if (accountSlug && !hasSection) {
        return <Redirect to={`${basePath}/pools`} />
    }

    return (
        <>
            <DiscountsSectionTabs />
            <DiscountsHeader
                onClickNewDiscount={() => {
                    setHash('add_discount')
                }}
                onClickNewDiscountPool={() => setHash('add_discount_pool')}
            />
            <div id="discounts-table-container">
                <DiscountsToolbar />
                {children}
            </div>
            <div className="discount-modals">
                {hash.route === 'add_discount' && <AddDiscountModal selectedPoolUuid={poolUuid} />}
                {hash.route === 'add_discount_pool' && <AddPoolModal />}
                {hash.route === 'delete_pool' && poolUuid && <DeletePoolModal poolUuid={poolUuid} />}
                {hash.route === 'edit_discount' && codeUuid && poolUuid && accountSlug && (
                    <EditDiscountModal codeUuid={codeUuid} poolUuid={poolUuid} accountSlug={accountSlug} />
                )}
            </div>
            {hash.route === 'redeem_unused_codes' && codeUuid && codeType && ['upload', 'code'].includes(codeType) && (
                <RedeemCodes codeUuid={codeUuid} codeType={codeType} />
            )}
        </>
    )
}
